import { CustomerBalances } from '../../models/sale'
import {
  AbpBalanceType,
  getAbpOutstandingBalance,
  resolveAbpCappedAmount,
} from '../../constants/abp-balance-type'
import { resolveAbpInitialAmount } from './resolveAbpInitialAmount'

/**
 * Resolves and safely caps URL-prefilled account balance payment (ABP) amount using customer balance buckets.
 *
 * This helper exists to keep the full initialization decision path in one place:
 * 1) derive outstanding debt for the selected balance type,
 * 2) apply existing URL amount parsing/validation,
 * 3) apply final defensive capping against selected balances.
 *
 * Keeping this composition in a dedicated function allows unit tests to cover
 * the sale-initialization wiring without mounting the `useSaleInitialising` hook.
 */
export const resolveAbpInitialAmountForBalances = (
  prefilledAmountParam: string | null,
  balances: Pick<
    CustomerBalances,
    'account' | 'onAccountBalance' | 'laybyBalance'
  >,
  balanceType: AbpBalanceType | null
): number => {
  const outstandingBalance = getAbpOutstandingBalance(balances, balanceType)

  return resolveAbpCappedAmount(
    resolveAbpInitialAmount(prefilledAmountParam, outstandingBalance),
    balances,
    balanceType
  )
}
